/* ── Lock fixed bars against mobile browser chrome movement ──
     Sets explicit pixel top/bottom on the navbar, promo banner and bottom bar
     ONCE on load, then never again. Uses visualViewport API where available
     (Chrome 61+, Safari 13+) which gives the stable layout viewport size,
     not the shifting visual viewport. */
  (function lockBars() {
    function applyLock() {
      var navbar  = document.getElementById('crazxy-navbar');
      var promo   = document.getElementById('crazxy-promo-banner');
      var bottom  = document.getElementById('czx-bottom-bar');

      /* Force compositing layer on each fixed element — translateZ(0) is sufficient,
         will-change removed as it causes excess GPU layers on Android WebView */
      [navbar, promo, bottom].forEach(function(el) {
        if (!el) return;
        el.style.webkitTransform = 'translateZ(0)';
        el.style.transform = 'translateZ(0)';
        el.style.webkitBackfaceVisibility = 'hidden';
        el.style.backfaceVisibility = 'hidden';
      });

      /* Lock bottom bar to bottom:0 explicitly */
      if (bottom) {
        bottom.style.bottom = '0px';
        bottom.style.position = 'fixed';
      }
    }

    /* Run immediately and after first paint */
    applyLock();
    requestAnimationFrame(applyLock);

    /* On mobile, prevent resize events fired by browser chrome from
       causing layout recalculation. Use visualViewport if available. */
    if (window.visualViewport) {
      /* visualViewport fires when only the visible area changes (keyboard, chrome)
         but NOT when the layout viewport changes — so we can ignore it for bars */
      window.visualViewport.addEventListener('resize', function() {
        /* Re-lock after keyboard or chrome change — keeps bars pinned */
        applyLock();
      });
    }
  })();

(function () {
    var SESSION_KEY      = 'czx_back_ref';
    var CHAR_SESSION_KEY = 'czx_char_back_ref';
    /* localStorage mirror — Instagram IAB doesn't fire beforeunload reliably,
       and document.referrer is empty for same-origin navigations inside IAB.
       localStorage persists across navigations so we can always recover the ref. */
    var LS_KEY      = 'czx_back_ref_ls';
    var LS_CHAR_KEY = 'czx_char_back_ref_ls';

    function isSourcePage() {
      var path = window.location.pathname;
      if (path === '/') return true;
      if (path.indexOf('/pages/all-product') === 0) return true;
      if (path.indexOf('/pages/wishlist') === 0) return true;
      if (path.indexOf('/collections/') === 0) return true;
      if (path.indexOf('/pages/characters') === 0) return true;
      return false;
    }

    var isCharCollection = document.body.classList.contains('template-collection-character');

    function sourceLabel(url) {
      var path = url.split('?')[0].replace(window.location.origin, '');
      if (path === '/' || path === '') return 'Home';
      if (path.indexOf('/pages/all-product') !== -1) return 'All Products';
      if (path.indexOf('/pages/wishlist') !== -1) return 'Wishlist';
      if (path.indexOf('/pages/characters') !== -1) return 'All Characters';
      var m = path.match(/\/collections\/([^\/]+)/);
      if (m) return m[1].replace(/-/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
      return 'Back';
    }

    var isProduct = document.body.classList.contains('template-product');

    /* ══ SOURCE PAGES: save back ref ══ */
    if (isSourcePage()) {
      function saveRef() {
        var data = JSON.stringify({ url: window.location.href, scrollY: window.scrollY });
        try { sessionStorage.setItem(SESSION_KEY, data); } catch(e) {}
        try { localStorage.setItem(LS_KEY, data); } catch(e) {}
      }
      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.href;
        if (href.indexOf(window.location.origin) !== 0) return;
        if (href.indexOf('/products/') === -1) return;
        saveRef();
      }, true);
      window.addEventListener('beforeunload', saveRef);
      saveRef(); /* save immediately on arrival */
    }

    /* ══ ALL CHARACTERS PAGE + HOME: save char back ref ══ */
    (function saveCharBackRef() {
      var path = window.location.pathname;
      var isCharPage = path.indexOf('/pages/characters') === 0;
      var isHome = (path === '/');
      if (!isCharPage && !isHome) return;

      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href]');
        if (!link) return;
        var href = link.href;
        if (href.indexOf(window.location.origin) !== 0) return;
        if (href.indexOf('/collections/') === -1) return;
        var data = JSON.stringify({
          url: window.location.href, scrollY: window.scrollY,
          label: isCharPage ? 'All Characters' : 'Home',
          source: isCharPage ? 'characters' : 'home-marquee'
        });
        try { sessionStorage.setItem(CHAR_SESSION_KEY, data); } catch(e) {}
        try { localStorage.setItem(LS_CHAR_KEY, data); } catch(e) {}
      }, true);
    })();

    /* ══ PRODUCT PAGE: show back button ══ */
    if (isProduct) {
      var stored = null;
      /* 1. Try sessionStorage first */
      try { stored = JSON.parse(sessionStorage.getItem(SESSION_KEY)); } catch(e) {}
      /* 2. Fall back to localStorage (survives Instagram IAB navigation) */
      if (!stored || !stored.url) {
        try { stored = JSON.parse(localStorage.getItem(LS_KEY)); } catch(e) {}
      }
      /* 3. Last resort: document.referrer (works in Chrome but not IAB) */
      if (!stored || !stored.url) {
        var ref = document.referrer;
        if (ref && ref.indexOf(window.location.origin) === 0) {
          var refPath = ref.replace(window.location.origin, '').split('?')[0];
          var isValidRef = (
            refPath === '/' ||
            refPath.indexOf('/pages/all-product') === 0 ||
            refPath.indexOf('/pages/wishlist') === 0 ||
            refPath.indexOf('/collections/') === 0 ||
            refPath.indexOf('/pages/characters') === 0
          );
          if (isValidRef) stored = { url: ref, scrollY: 0 };
        }
      }

      if (stored && stored.url) {
        var btn = document.getElementById('czx-back-btn');
        var lbl = document.getElementById('czx-back-btn-label');
        if (btn) {
          lbl.textContent = sourceLabel(stored.url);
          btn.href = stored.url;
          btn.style.display = 'flex';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var targetUrl = stored.url;
            var targetScroll = stored.scrollY || 0;
            try { sessionStorage.removeItem(SESSION_KEY); } catch(e) {}
            try { localStorage.removeItem(LS_KEY); } catch(e) {}
            try { sessionStorage.setItem('czx_restore_scroll', String(targetScroll)); } catch(e) {}
            window.location.href = targetUrl;
          });
        }
      }
    }

    /* ══ CHARACTER COLLECTION PAGE: show back button ══ */
    if (isCharCollection) {
      var charStored = null;
      try { charStored = JSON.parse(sessionStorage.getItem(CHAR_SESSION_KEY)); } catch(e) {}
      if (!charStored || !charStored.url) {
        try { charStored = JSON.parse(localStorage.getItem(LS_CHAR_KEY)); } catch(e) {}
      }
      if (!charStored || !charStored.url) {
        var ref = document.referrer;
        if (ref && ref.indexOf(window.location.origin) === 0) {
          var refPath = ref.replace(window.location.origin, '').split('?')[0];
          if (refPath === '/' || refPath.indexOf('/pages/characters') === 0) {
            charStored = {
              url: ref, scrollY: 0,
              label: refPath.indexOf('/pages/characters') === 0 ? 'All Characters' : 'Home'
            };
          }
        }
      }

      var btn = document.getElementById('czx-back-btn');
      var lbl = document.getElementById('czx-back-btn-label');
      if (btn) {
        if (charStored && charStored.url) {
          lbl.textContent = charStored.label || 'All Characters';
          btn.href = charStored.url;
          btn.style.display = 'flex';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var targetUrl = charStored.url;
            var targetScroll = charStored.scrollY || 0;
            try { sessionStorage.removeItem(CHAR_SESSION_KEY); } catch(e) {}
            try { localStorage.removeItem(LS_CHAR_KEY); } catch(e) {}
            try { sessionStorage.setItem('czx_restore_scroll', String(targetScroll)); } catch(e) {}
            window.location.href = targetUrl;
          });
        } else {
          lbl.textContent = 'All Characters';
          btn.href = '/pages/characters';
          btn.style.display = 'flex';
        }
      }
    }

    /* ══ RESTORE SCROLL on arrival ══ */
    if (isSourcePage() || isCharCollection) {
      var restoreY = null;
      try { restoreY = sessionStorage.getItem('czx_restore_scroll'); } catch(e) {}
      if (restoreY) {
        try { sessionStorage.removeItem('czx_restore_scroll'); } catch(e) {}
        var y = parseInt(restoreY, 10);
        requestAnimationFrame(function () {
          setTimeout(function () { window.scrollTo({ top: y, behavior: 'instant' }); }, 80);
        });
      }
    }
  })();